const PlayButton = () => {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.0625 38.9375C5.625 38.9375 5.125 38.8125 4.75 38.5625C3.875 38.0625 3.375 37.25 3.375 36.25V3.75C3.375 2.8125 3.875 1.9375 4.75 1.4375C5.625 0.937496 6.625 0.999996 7.5 1.5L35.5 17.8125C36.3125 18.3125 36.75 19.125 36.75 20.0625C36.75 20.9375 36.3125 21.8125 35.5 22.25L7.4375 38.5C7 38.75 6.5 38.9375 6.0625 38.9375ZM6.125 4V36L33.625 20L6.125 4Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default PlayButton;
